import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { BlockConnector } from './BlockConnector';
import { BlockContextProvider, useBlockContext } from './BlockContext';
export function RootZone(_ref) {
  var _ref2;
  var piletApi = _ref.piletApi,
    allViews = _ref.allViews,
    startingViewRID = _ref.startingViewRID,
    contractData = _ref.contractData;
  var _useBlockContext = useBlockContext(),
    contractDataSourcesFromParentBlock = _useBlockContext.contractDataSources;
  var _React$useState = React.useState(undefined),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    viewFromState = _React$useState2[0],
    setSelectedView = _React$useState2[1];
  var firstView = allViews[0];
  var activeView = (_ref2 = viewFromState !== null && viewFromState !== void 0 ? viewFromState : allViews.find(function (x) {
    return x.rid === startingViewRID;
  })) !== null && _ref2 !== void 0 ? _ref2 : firstView;
  var contractDataSources = React.useMemo(function () {
    var sources = [];
    if (contractDataSourcesFromParentBlock) {
      sources.push.apply(sources, _toConsumableArray(contractDataSourcesFromParentBlock));
    }
    if (contractData) {
      sources.push(contractData);
    }
    return sources;
  }, [contractData, contractDataSourcesFromParentBlock]);
  return /*#__PURE__*/React.createElement(BlockContextProvider, {
    view: activeView,
    piletApi: piletApi,
    blockRID: activeView.rootBlockRID,
    allViews: allViews,
    changeView: setSelectedView,
    contractSources: contractDataSources
  }, /*#__PURE__*/React.createElement(RootConnector, null));
}
function RootConnector() {
  var _useBlockContext2 = useBlockContext(),
    block = _useBlockContext2.block;
  return /*#__PURE__*/React.createElement(BlockConnector, {
    block: block
  });
}